import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "recipientType", "customer", "ecommerceCustomer", "numberField" ]

  toggleField() {
    const recipientType = this.recipientTypeTarget.value;

    this.customerTarget.style.display = recipientType === "customer" ? "block" : "none";
    this.ecommerceCustomerTarget.style.display = recipientType === "ecommerce_customer" ? "block" : "none";
    this.numberFieldTarget.style.display = recipientType === "specific" ? "block" : "none";
  }

  async updateCustomerCount() {
    const recipientType = this.element.querySelector('select[name="recipient_type"]').value
    const phoneEl = this.element.querySelector('select[name="phone"]')
    const numbersEl = this.element.querySelector('textarea[name="numbers_text"]')

    const params = new URLSearchParams({ recipient_type: recipientType })
    if (phoneEl && phoneEl.value) params.append('phone', phoneEl.value)
    if (numbersEl && numbersEl.value) params.append('numbers_text', numbersEl.value)

    const resp = await fetch(`/whatsapp_count_messages?${params.toString()}`)
    const data = await resp.json()
    this.updateCustomerCountUI(data.count)
  }

  updateCustomerCountUI(count) {
    const countElement = this.element.querySelector('#whatsapp-customer-count');
    if (countElement) { countElement.textContent = count; }
  }
}
